module.exports = __webpack_public_path__ + "static/img/jdy4.65402eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/jdy4.png
// module id = kcw7
// module chunks = 0